import { render, staticRenderFns } from "./ActivitiesTable.vue?vue&type=template&id=b2d35bb6&scoped=true"
import script from "./ActivitiesTable.vue?vue&type=script&lang=js"
export * from "./ActivitiesTable.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesTable.vue?vue&type=style&index=0&id=b2d35bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d35bb6",
  null
  
)

export default component.exports